<template>
  <div class="container">
    <div style="padding: 12px; background-color: #f7faee; margin-bottom: 10px; border-radius: 5px;">
      <h1 class="title">{{ survey.title }} <small>(#{{ survey.id }})</small></h1>

      <b-input type="textarea" v-model="survey.description" placeholder="お願い文言"/>
    </div>

    <div class="inner-container">
      <div style="padding: 8px; background-color: #18112a; border-radius: 5px; flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
        <div :class="{'field': survey.questions.length}">
          <draggable v-model="survey.questions">
            <transition-group name="animation">
              <div class="field" style="padding: 10px; background-color: #eee; border-radius: 5px;"
                v-for="(question, questionIndex) in survey.questions"
                :key="'question' + question.id"
              >
                <div style="display: flex; margin-left: -10px; margin-right: -10px;">
                  <div style="margin: 0 10px;">
                    <div class="field">
                      <b-select placeholder="タイプ" v-model="survey.questions[questionIndex].type" @input="questionTypeChanged(survey.questions[questionIndex])">
                        <optgroup label="選択肢なし">
                          <option value="text">テキスト</option>
                          <option value="textarea">テキストエリア</option>
                        </optgroup>
                        <optgroup label="選択肢あり">
                          <option value="radio">ラジオ</option>
                          <option value="checkbox">チェックボックス</option>
                        </optgroup>
                      </b-select>
                    </div>

                    <div class="field">
                      <label class="label">入力チェック</label>
                    </div>
                    <div class="field" style="padding: 10px; border-radius: 5px; background-color: #f3f3f3;">
                      <div class="field">
                        <b-checkbox v-model="survey.questions[questionIndex].validation_required">必須項目</b-checkbox>
                      </div>
                    </div>
                    <div class="field" style="padding: 10px; border-radius: 5px; background-color: #f3f3f3;">
                      <div class="field" >
                        <b-switch v-model="survey.questions[questionIndex].guide_text_enabled">補足説明を表示する</b-switch>
                      </div>
                      <div class="field" >
                        <b-input type="text" placeholder="補足説明" v-model="survey.questions[questionIndex].guide_text" />
                      </div>
                    </div>
                  </div>

                  <div style="flex: 1; margin: 0 10px;">
                    <div class="field">
                      <b-input type="text" placeholder="設問" v-model="survey.questions[questionIndex].title" />
                    </div>

                    <div
                      v-if="survey.questions[questionIndex].type == 'radio' || survey.questions[questionIndex].type == 'checkbox'"
                    >
                      <draggable class="field" v-model="survey.questions[questionIndex].options"
                        style="margin-top: 10px; padding: 10px; background-color: #f3f3f3; border-radius: 5px;"
                      >
                        <div class="field"
                          style="background-color: #fafafa; border-radius: 5px; display: flex;"
                          v-for="(option, optionIndex) in survey.questions[questionIndex].options"
                          :key="'option' + option.id"
                        >
                          <div style="padding: 10px; flex: 1;">
                            <div class="field">
                              <b-input type="text" placeholder="選択肢" v-model="survey.questions[questionIndex].options[optionIndex].title" />
                            </div>
                            <div class="field">
                              <b-checkbox
                                v-model="survey.questions[questionIndex].options[optionIndex].require_text_input"
                                :disabled="survey.questions[questionIndex].type !== 'radio'"
                              >
                                選択された場合、テキスト入力を表示する
                              </b-checkbox>
                            </div>
                          </div>
                          <div
                            style="padding: 6px 10px 6px 2px; cursor: pointer; display: flex; align-items: center;"
                            class="has-text-danger"
                            @click="survey.questions[questionIndex].options.splice(optionIndex, 1)"
                          >
                            <b-icon icon="close" />
                          </div>
                        </div>
                      </draggable>

                      <div style="padding: 10px 0; text-align: right;">
                        <button type="button" class="button is-default" @click="addOption(question)">選択肢追加</button>
                      </div>
                    </div>

                  </div>

                  <div
                    style="padding: 6px 10px 6px 2px; cursor: pointer; display: flex; align-items: start;"
                    class="has-text-danger"
                    @click="survey.questions.splice(questionIndex, 1)"
                  >
                    <b-icon icon="close" />
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>

        <div style="padding: 0; text-align: right;">
          <button type="button" class="button is-default" @click="addQuestion()">設問追加</button>
        </div>
      </div>

      <div style="padding: 8px; background-color: #f7faee; border-radius: 5px; margin-left: 10px; justify-content: space-between; display: flex; flex-direction: column;">
        <div>
          <div class="field">
            <button @click="modals.preview = !modals.preview" class="button is-primary is-fullwidth">プレビュー</button>
          </div>

          <div class="field">
            <button @click="submit()" class="button is-success is-fullwidth">保存する</button>
          </div>

          <div class="field has-text-centered">
            <div style="padding: 10px 0">
              <strong>設問数:</strong> {{ survey.questions.length }}件
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="modals.preview">
      <div style="background-color: #fff; padding: 20px; border-radius: 5px; max-height: 90vh; overflow: scroll;">
        <SurveyPreview :survey="survey"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import axios from '@/axios'
import SurveyPreview from './Modals/SurveyPreview'

export default {
  components: {
    SurveyPreview,
    draggable,
  },

  created() {
    axios.get('/api/app/surveys/' + this.id).then(({ data }) => {
      this.survey = data.data
    })
  },

  data() {
    return {
      modals: {
        preview: false,
      },
      survey: {
        questions: [],
      }
    }
  },

  computed: {
    id() {
      return this.$route.params.id
    }
  },

  methods: {
    submit() {
      axios.patch('/api/app/surveys/' + this.id, {description: this.survey.description, questions: this.survey.questions}).then(({ data }) => {
        this.$toast.open({
          message: `保存しました。`,
          type: 'is-success'
        })

        this.survey = data.data
      })
    },

    addQuestion() {
      this.survey.questions.push({
        id: this.guidGenerator(),
        title: '',
        type: 'text',
        options: [],
        validation_required: false,
        guide_text_enabled: false,
        guide_text: '',
      })
    },

    addOption(question) {
      question.options.push({
        id: this.guidGenerator(),
        title: '',
        require_text_input: false,
      })
    },

    guidGenerator() {
      var S4 = function() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      };

      return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    },

    questionTypeChanged(question) {
      if (question.type == 'text') {
        question.options = []
      }
      if (question.type == 'radio' || question.type == 'checkbox') {
        if (question.options == 0) {
          this.addOption(question)
          this.addOption(question)
        }
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 960px;
  margin: 0 auto;
}

.inner-container {
  display: flex;
}

.animation-item {
  display: inline-block;
  margin-right: 10px;
}
.animation-enter-active, .animation-leave-active {
  transition: all .5s;
}
.animation-enter, .animation-leave-to /* .animation-leave-active below version 2.1.8 */ {
  opacity: 0;
  transsurvey: translateX(10px);
}
</style>
